var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9187 9.88665L7.9187 4.69666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4187 16.4867V8.48672C21.4183 8.13599 21.3258 7.79153 21.1502 7.48788C20.9747 7.18423 20.7224 6.93208 20.4187 6.75672L13.4187 2.75672C13.1147 2.58118 12.7698 2.48877 12.4187 2.48877C12.0676 2.48877 11.7227 2.58118 11.4187 2.75672L4.4187 6.75672C4.11496 6.93208 3.86268 7.18423 3.68716 7.48788C3.51164 7.79153 3.41906 8.13599 3.4187 8.48672V16.4867C3.41906 16.8374 3.51164 17.1819 3.68716 17.4856C3.86268 17.7892 4.11496 18.0414 4.4187 18.2167L11.4187 22.2167C11.7227 22.3923 12.0676 22.4847 12.4187 22.4847C12.7698 22.4847 13.1147 22.3923 13.4187 22.2167L20.4187 18.2167C20.7224 18.0414 20.9747 17.7892 21.1502 17.4856C21.3258 17.1819 21.4183 16.8374 21.4187 16.4867Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68872 7.44666L12.4187 12.4967L21.1487 7.44666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4187 22.5667V12.4867",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.40c4dc6c0e1b31cdac65ad0af0e8d4a8.svg";
export { ForwardRef as ReactComponent };